import { ScrollArea } from "./ui/scroll-area";
import { useIntersectionObserver } from "../hooks/useIntersectionObserver";
import { AspectRatio } from "./ui/aspect-ratio";
const Integrations = () => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true
  });
  const platforms = [{
    name: "Meta",
    iconSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Meta_Platforms_Inc._logo.svg/512px-Meta_Platforms_Inc._logo.svg.png"
  }, {
    name: "Google Ads",
    iconSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Google_Ads_logo.svg/512px-Google_Ads_logo.svg.png"
  }, {
    name: "TikTok",
    iconSrc: "https://upload.wikimedia.org/wikipedia/en/thumb/a/a9/TikTok_logo.svg/512px-TikTok_logo.svg.png"
  }, {
    name: "Shopify",
    iconSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Shopify_logo_2018.svg/512px-Shopify_logo_2018.svg.png"
  }];
  return <div className="px-6">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={`bg-white rounded-2xl p-8 transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-4xl md:text-5xl font-charter mb-8 text-center">
            All your data.<br className="md:hidden" /> One platform.
          </h2>
          <p className="text-center text-muted-foreground mb-6 md:mb-12 max-w-2xl mx-auto">
            Seamlessly connect with your favorite platforms and tools to streamline your workflow.
          </p>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 border-2 border-dashed border-gray-300 rounded-xl p-6">
            {platforms.map((platform, index) => <div key={index} className="flex items-center justify-center p-4 px-0">
                <img src={platform.iconSrc} alt={platform.name} className="w-20 h-20 md:w-24 md:h-24 object-contain transition-all duration-300" />
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};
export default Integrations;